import OrganiserService from "../../services/OrganiserService";

export const GET_ORGANISER_SUCCESS = "GET_ORGANISER_SUCCESS";
export const GET_ORGANISER_FAILURE = "GET_ORGANISER_FAILURE";
export const GET_ORGANISER_LOADING = "GET_ORGANISER_LOADING";
export const GET_LIVE_EVENTS_SUCCESS = "GET_LIVE_EVENTS_SUCCESS";
export const GET_LIVE_EVENTS_FAILURE = "GET_LIVE_EVENTS_FAILURE";
export const GET_LIVE_EVENTS_LOADING = "GET_LIVE_EVENTS_LOADING";
export const GET_PAST_EVENTS_SUCCESS = "GET_PAST_EVENTS_SUCCESS";
export const GET_PAST_EVENTS_FAILURE = "GET_PAST_EVENTS_FAILURE";
export const GET_PAST_EVENTS_LOADING = "GET_PAST_EVENTS_LOADING";
export const UPDATE_TAB_PAGE = "UPDATE_TAB_PAGE";

export const getOrganiser = id => {
  return dispatch => {
    dispatch({ type: GET_ORGANISER_LOADING });
    OrganiserService.get(id)
      .then(organiser => {
        dispatch({ type: GET_ORGANISER_SUCCESS, organiser: organiser });
      })
      .catch(err => {
        dispatch({ type: GET_ORGANISER_FAILURE, organiser: organiser });
      });
  };
};

export const loadLiveEventsByOrganiser = (organiserId, page = 0, tab) => {
  return dispatch => {
    dispatch({ type: GET_LIVE_EVENTS_LOADING, page: page });
    OrganiserService.getEventsbyOrganiserId(organiserId, page, tab)
      .then(response => {
        dispatch({
          type: GET_LIVE_EVENTS_SUCCESS,
          events: response.events,
          numEvents: response.total
        });
      })
      .catch(err => {
        dispatch({ type: GET_LIVE_EVENTS_FAILURE });
      });
  };
};

export const loadPastEventsByOrganiser = (organiserId, page = 0, tab) => {
  return dispatch => {
    dispatch({ type: GET_PAST_EVENTS_LOADING, page: page });
    OrganiserService.getEventsbyOrganiserId(organiserId, page, tab)
      .then(response => {
        dispatch({
          type: GET_PAST_EVENTS_SUCCESS,
          events: response.events,
          numEvents: response.total
        });
      })
      .catch(err => {
        dispatch({ type: GET_PAST_EVENTS_FAILURE });
      });
  };
};

export const changeTab = tab => {
  return dispatch => {
    dispatch({ type: UPDATE_TAB_PAGE, tab: tab });
  };
};
